// extracted by mini-css-extract-plugin
export default {"container":"Co-z","blurb":"Do-z","links":"Eo-z"};